module.exports = __webpack_public_path__ + "img/noData.5881484b.png";